import { type Context, createContext, useContext } from "react";
import type { PublicAnnouncement } from "@/features/announce/api/announceClient";

export interface AnnouncementStatus {
  hasUnreadAnnouncements: boolean;
  isAnnouncementMetaReady: boolean;
  isAnnouncementMetaPending: boolean;
  isAnnouncementRead: (
    announcement: Pick<
      PublicAnnouncement,
      "id" | "published_at" | "article_unread_revision"
    >,
  ) => boolean;
  markAnnouncementRead: (
    announcement: Pick<
      PublicAnnouncement,
      "id" | "published_at" | "article_unread_revision"
    >,
  ) => void;
  markAnnouncementsReadThrough: (
    publishedAt: string | null,
    articleUnreadRevision?: number | null,
  ) => void;
  markCurrentAnnouncementsRead: (
    announcements?: readonly Pick<
      PublicAnnouncement,
      "article_unread_revision" | "published_at"
    >[],
    snapshotRevision?: number | null,
  ) => void;
}

export const AnnouncementStatusContext: Context<AnnouncementStatus> =
  createContext<AnnouncementStatus>({
    hasUnreadAnnouncements: false,
    isAnnouncementMetaReady: false,
    isAnnouncementMetaPending: false,
    isAnnouncementRead: () => true,
    markAnnouncementRead: (): void => undefined,
    markAnnouncementsReadThrough: (): void => undefined,
    markCurrentAnnouncementsRead: (): void => undefined,
  });

export function useAnnouncementStatus(): AnnouncementStatus {
  return useContext(AnnouncementStatusContext);
}
